import React from 'react';
import { makeStyles } from '@mui/styles';
import {Button, Dialog, AppBar, Toolbar, IconButton, Typography, Slide, DialogContent} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  root: {
    flexGrow: 1,
    marginBottom: 40,
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogoPantallaCompleta = ({openFullScreenDialog, handleClose, title, children, fullscreen, maxWidth, disableEscapeKeyDown, showIconButton, showButtonClose}) => {
  const classes = useStyles();
  return (
    <div>
      <Dialog
        fullScreen={fullscreen}
        open={openFullScreenDialog}
        onClose={(_, reason) => {
          if(reason === 'backdropClick') return;
          handleClose()
        }}
        TransitionComponent={Transition}
        maxWidth={maxWidth}
        aria-labelledby="confirmation-dialog-title"
        disableEscapeKeyDown={disableEscapeKeyDown}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            {showIconButton && (
              <IconButton edge="start" color="inherit" onClick={handleClose} style={{background: 'red', color: "white"}} aria-label="close">
                <CloseIcon />
              </IconButton>
            )}
            <Typography variant="h6" className={classes.title}>
              {title}
            </Typography>
            {showButtonClose && (
              <Button autoFocus color="inherit" onClick={handleClose} style={{background: 'red', color: "white", }}>
                <CloseIcon /> Cerrar
              </Button>
            )}
          </Toolbar>
        </AppBar>
        <DialogContent className={classes.root}>
            {children}
        </DialogContent>
      </Dialog>
    </div>
  );
}

DialogoPantallaCompleta.propTypes = {
  openFullScreenDialog: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
};

DialogoPantallaCompleta.defaultProps = {
  fullscreen: false,
  maxWidth: "xl",
  disableEscapeKeyDown: true,
  showIconButton: false,
  showButtonClose: true,
};

export default DialogoPantallaCompleta;
